var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronIcon } from '@core';
import { twMerge } from 'tailwind-merge';
export var DropdownSelectButton = function (_a) {
    var displayText = _a.displayText, className = _a.className, textClassName = _a.textClassName, Icon = _a.Icon, iconClassName = _a.iconClassName, title = _a.title;
    return (_jsxs("div", __assign({ className: twMerge('flex flex-row items-center justify-between rounded-lg px-[12px] py-[6px]', className), title: title }, { children: [_jsx("p", __assign({ className: twMerge('font-sans text-sm font-normal text-input-label-primary', textClassName) }, { children: displayText })), Icon ? (_jsx(Icon, { className: twMerge('h-[20px] w-[20px]', iconClassName) })) : (_jsx(ChevronIcon, { className: twMerge('w-[20px]', iconClassName) }))] })));
};
